export const UnleashFeatureNames = {
  empIsNewLoginVerificationEnabled: 'empIsNewLoginVerificationEnabled',
  empNewResumeViewer: 'empNewResumeViewer',
  empEmployerInitChat: 'empEmployerInitChat',
  empIsVerificationPromptEnabled: 'empIsVerificationPromptEnabled',
  empAllowCollegeDegreeInVN: 'empAllowCollegeDegreeInVN',
  empNotifyNewVNMonetizedFeatures: 'empNotifyNewVNMonetizedFeatures',
  allUseOSS: 'allUseOSS',
  empJobShareIncentive: 'empJobShareIncentive',
  empAllHideSelfServePremiumPlan: 'empAllHideSelfServePremiumPlan',
  empSubscriptionPurchaseForPremiumPlan:
    'empSubscriptionPurchaseForPremiumPlan',
  empLandingPageExperiment: 'empLandingPageExperiment',
  empJobMetricsLimit: 'empJobMetricsLimit',
  allEmpCompanyAddress: 'allEmpCompanyAddress',
  empAllBlockingFeature: 'empAllBlockingFeature',
  empAIGenJobDescription: 'empAIGenJobDescription',
  empAllAutoGenerateJobDesc: 'empAllAutoGenerateJobDesc',
  empSortByRelevancy: 'empSortByRelevancy',
  allEmpProfessionalEducation: 'allEmpProfessionalEducation',
  empLegalDocsAutoVerify: 'empLegalDocsAutoVerify',
  empAllShortlistPackageExp: 'empAllShortlistPackageExp',
  empAllVipPromo: 'empAllVipPromo',
  empAllHJPricingExp: 'empAllHJPricingExp',
  empAllUnverifiedCompaniesSgMyPostJobs:
    'empAllUnverifiedCompaniesSgMyPostJobs',
  empHotJobRTAdoption: 'empHotJobRTAdoption',
  empJobLevelMessages: 'empJobLevelMessages',
  empJobStatusOnApplicationRecord: 'empJobStatusOnApplicationRecord',
  empJobPostingPrefill: 'empJobPostingPrefill',
  empAllTalentRecommendationLLM: 'empAllTalentRecommendationLLM',
  empMigrateMeToV2: 'empMigrateMeToV2',
  empRoleSwitching: 'empRoleSwitching',
  empAllUsePaymentSystemV2SG: 'empAllUsePaymentSystemV2SG',
  empAllUsePaymentSystemV2ID: 'empAllUsePaymentSystemV2ID',
  empAllKeywordMatching: 'empAllKeywordMatching',
  empAIGenJobDescriptionKeywords: 'empAIGenJobDescriptionKeywords',
};
